// Angular imports
import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot } from '@angular/router';

// Rxjs import
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

// 3rd party imports
import notify from 'devextreme/ui/notify';

// CC-Common imports
import { Utils } from 'cc-common';

// Service imports
import { CommunityService } from '../_services/data-services/community.service';

// Model imports
import { CommunitySelectorResultDto } from '../_models/community-selector-result-dto';

// Constant imports
import { MessageInterval } from '../_constants/messages-intervals';

@Injectable({
    providedIn: 'root'
})
export class CommunityGuard implements CanActivate {
    communityIds: number[];

    constructor(private readonly router: Router, private readonly communityService: CommunityService) {}

    canActivate(route: ActivatedRouteSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        const communityId = parseInt(route.params.communityId, 10);
        if (Utils.isNullOrUndefined(this.communityIds)) {
            return this.checkCummunityAccess(communityId);
        } else {
            return this.hasCommunityAccess(communityId);
        }
    }

    private checkCummunityAccess(communityId: number): Observable<boolean> {
        return this.communityService.getCommunities(false, true).pipe(
            map((communities: CommunitySelectorResultDto[]) => {
                this.communityIds = communities.map((r) => r.communityId);
                return this.hasCommunityAccess(communityId);
            })
        );
    }

    private hasCommunityAccess(communityId: number): boolean {
        const hasAccess = Utils.isInList(communityId, this.communityIds);
        if (Utils.isFalse(hasAccess)) {
            this.router.navigate(['home']);
            notify('Invalid route. Redirecting to Home', 'error', MessageInterval.defaultErrorMsgInterval);
        }
        return hasAccess;
    }
}
